/**
 * @title utility2.js: Global sub-module
 * @description A collection of functions used application wide, except Home, Browse & Product pages.
 * Functions that are not needed for Home, Browse & Product pages should live in this file
 * This module should contain generic utility code. No module specifics.
 */
define(function() {
  let util = {
	POSTAL_CODE_REGEX_US: /^(\d{5}(-\d{4})?$)$/,
	POSTAL_CODE_REGEX_CA: /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/,
	ATLEAST_ONE_ALPHABET: /^(?=.*[A-Za-z\u00C0-\u017F]).+/,
	CC_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\&\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
	LAST_NAME_FIELD_REGEX: /[^0-9A-Z\.\'\-\s\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u2030\u20AC]/i,
    /*
     * Function used to escape double ticks (ADA)
     **/
    encode_html: function(input) {
      input = input.replace('"', '&#34');
      input = input.replace('\'', '&#39');
      input = input.replace(';', '&#59');
      return input;
    },
    /**
     * Function used to "extend" the bootstap popover capability to add accesibility features
     * function add a couple of the ADA needed attributes and a couple of keyboard navigation listener
     * popover parameters are expected to be defined in the element as normal bootsrap popover
     */
    accesible_popover: function(selector) {
      let popoverElement = $(selector);
      popoverElement.popover()
        .on('keydown', function(event) {
          if (event.which == 13)
            $(this).popover('toggle');
          if (event.which == 27)
            $(this).popover('hide');
        })
        .on('blur', function() {
          $(this).popover('hide');
        })
        .on('shown.bs.popover', function() {
          $(this).attr('aria-expanded', 'true');
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        });
    },
    /**
     * This function makes images in popover content tabbable for ADA purposes
     * @param {string} tooltipClass - Tooltip class.
     * @return {void}
     */
    activateKeyboardAccesiblePopover: function(selector) {
      let popoverElement = $('.' + selector);
      popoverElement.popover()
        .on('keydown', function(event) {
          //Enter event keycode
          if (event.which === 13) {
            $(this).popover('toggle');
          //Esc event keycode
          } else if (event.which === 27) {
            $(this).popover('hide');
          //Shift+Tab event keycode
          } else if (event.shiftKey && event.keyCode === 9) {
            $(this).popover('hide');
          }
        })
        .on('focus', function() {
          $(this).popover('toggle');
          let tooltipElement = $(this);
          let popoverContentId = $(this).attr('aria-describedby');
          if (popoverContentId !== undefined && $('#' + popoverContentId).find('img').length !== 0) {
            $('#' + popoverContentId).find('img').on('blur', function(){
              tooltipElement.popover('hide');
            });
          }
        })
        .on('shown.bs.popover', function() {
          $(this).attr('aria-expanded', 'true');
        })
        .on('hidden.bs.popover', function() {
          $(this).attr('aria-expanded', 'false');
        });
      $(':not(.' + selector + ')').on('click', function(){
        $('.co-help').each(function(){
          if ($(this).attr('aria-expanded') === 'true') {
            $(this).popover('hide');
          }
        })
      })
    },
    isMinimumScreen: function(min) {
      let width = $(window).width();
      if (min == 'DESKTOP' && width >= 1025) return true;
      if (min == 'TABLET-LANDSCAPE' && width >= 769) return true;
      if (min == 'TABLET-PORTRAIT' && width >= 668) return true;
      if (min == 'PHONE-LANDSCAPE' && width >= 376) return true;
      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
      return false;
    },
    isMaxScreen: function(min) {
      let width = $(window).width();
      if (min == 'DESKTOP' && width < 1024) return true;
      if (min == 'TABLET-LANDSCAPE' && width < 769) return true;
      if (min == 'TABLET-PORTRAIT' && width < 668) return true;
      if (min == 'PHONE-LANDSCAPE' && width < 376) return true;
      if (min == 'PHONE-PORTRAIT' && width >= 0) return true;
      return false;
    },
    /**
     * External link dialog for FORMS ONLY.
     */
    createExternalLinkDialogForForm: function(link, form, submitButtonTitle) {
      let dialogDiv = $('<div id="external_link_dialog">' + $('<div>').append(form.clone()).html() + '<span>' + messages.JS_LEAVING_DOMAIN_ALERT.replace('{0}', this.hostname) + '</span></div>');
      COSTCO.dialog.createExtDialogBox({
        title: messages.JS_DIALOG_EXTERNAL_LINK,
        body: dialogDiv,
        primary: submitButtonTitle,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: function() {
          $('#external_link_dialog form').submit();
          $('.costcoModalBtn1').first().click();
        },
      });
      return false;
    },
    /**
     * Return an array with only unique members. unique([1,2,1])
     * returns [2,1]
     * @param  {[array]} arr - The array with duplicated members
     * @return {[array]} out - The array with unique members
     */
    unique: function(arr) {
      let seen = {},
        out = [],
        len = arr.length,
        j = 0;
      for (let i = 0; i < len; i++) {
        let item = arr[i];
        if (seen[item] !== 1) {
          seen[item] = 1;
          out[j++] = item;
        }
      }
      return out;
    },
    /**
     * Return an array with a string interpolated between
     * each member i.e. interpolate([1,2],'+') returns [1,"+",2]
     * @param  {[array]} array - The array to interpolate
     * @param  {[type]} string - the element to interpolate in the array
     * @return {[type]} _array - The interpolated array
     */
    interpolate: function(array, _string) {
      let _array = [];
      for (let i = 0, len = array.length; i < len; i++) {
        _array.push(array[i]);
        if (i != array.length - 1) {
          _array.push(_string);
        }
      }
      return _array;
    },
    // Added for submitting encoded values without special characters
    encodeExclSpecialChars: function(input) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;
      input = COSTCO.util._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + this._keyStrExcl.charAt(enc1) + this._keyStrExcl.charAt(enc2) + this._keyStrExcl.charAt(enc3) + this._keyStrExcl.charAt(enc4);
      }
      return output;
    },
    // public method for decoding
    decodeExclSpecialChars: function(input) {
      let output = '';
      let chr1, chr2, chr3;
      let enc1, enc2, enc3, enc4;
      let i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
      while (i < input.length) {
        enc1 = this._keyStrExcl.indexOf(input.charAt(i++));
        enc2 = this._keyStrExcl.indexOf(input.charAt(i++));
        enc3 = this._keyStrExcl.indexOf(input.charAt(i++));
        enc4 = this._keyStrExcl.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = COSTCO.util._utf8_decode(output);
      output = output.replace(/[\u0000-\u0019]+/g, ''); // For removing the non-printable & Invalid JSON characters.
      return output;
    },
    addresses: [],
    addressLoadState: {
      shipping: {
        requested: 0,
        loaded: 0,
      },
      billing: {
        requested: 0,
        loaded: 0,
      },
    },
    resetAddressLoadState: function() {
      COSTCO.util.addresses = [];
      COSTCO.util.addressLoadState = {
        shipping: {
          requested: 0,
          loaded: 0,
        },
        billing: {
          requested: 0,
          loaded: 0,
        },
      };
    },
    getAddressBatchPage: function(addressType, filterName, filterOrder, total, processBatch, processPagination) {
      let start = 1,
        end = total; ;
      if (addressType == 'S') {
        addressLoadState = COSTCO.util.addressLoadState.shipping;
      } else {
        addressLoadState = COSTCO.util.addressLoadState.billing;
      }
      if (addressLoadState.requested == 0) {
        COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, start, total, processBatch, processPagination);
      } else {
        if (total > addressLoadState.requested) {
          COSTCO.util.getAddressBatch(addressType, filterName, filterOrder, addressLoadState, total + addressLoadState.requested, processBatch, processPagination);
        } else {
          if (typeof processBatch === 'function') processBatch(COSTCO.util.addresses);
          if (typeof processPagination === 'function') processPagination(COSTCO.util.addresses);
        }
      }
    },
    /* getAddresses
     * arguments can contain a list of callback functions to be executed on .done.  The last arg is a optional addressType (S || B) that retrieves a filtered list of addresses
     * */
    getAddressBatch: function(addressType, filterName, filterOrder, start, end, processBatch, processPagination) { // request the user's addresses 
   
      COSTCO.util.ajax({
        url: '/AjaxCostcoGetAddressCmd?requesttype=ajax',
        method: 'GET',
        dataType: 'json',
        data: {
          addressType: encodeURIComponent(addressType),
          filterName: encodeURIComponent(filterName),
          filterOrder: encodeURIComponent(filterOrder),
          start: encodeURIComponent(start),
          end: encodeURIComponent(end),
        },
        done: function(data, textStatus, jqXHR, options) {
          try {
            if (addressType == 'S') {
              COSTCO.util.addressLoadState.shipping.requested += parseInt(end);
              COSTCO.util.addressLoadState.shipping.loaded += parseInt(data.totalrecords);
            } else {
              COSTCO.util.addressLoadState.billing.requested += parseInt(end);
              COSTCO.util.addressLoadState.billing.loaded += parseInt(data.totalrecords);
            }
            if ( typeof(data.addresses) !== 'undefined') {
              COSTCO.util.mergeAddresses(JSON.parse(data.addresses));
            }
          } catch (err) { //
            console.error(err, 'Parse error');
          }
          if (typeof processBatch === 'function') processBatch(data);
          if (typeof processPagination === 'function') processPagination(data);
        },
      });
    },
    mergeAddresses: function(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].hasOwnProperty('addressId')) {
          COSTCO.util.renameArray(data[i], COSTCO.util.addressNamingMap);
        }
      }
      COSTCO.util.addresses = COSTCO.util.addresses.concat(data);
    },
    /**
     * Add every unique address from 'addresses' to
     * COSTCO.util.addresses
     * @param  {array} addresses [
     * @return {void}
     */
    concatNonDuplicates: function(addresses) {
      addresses.forEach((address) => {
        if (!this.any(this.addresses, (x) => x.id == address.id)) {
          this.addresses.push(address);
        }
      });
    },
    /*
     * Address naming is a mess
     */
    addressNamingMap: {
      addressId: 'id',
      addressTypeId: 'addressType',
      addressLine1: 'line1',
      addressLine2: 'line2',
      firstName: 'first',
      lastName: 'last',
      companyName: 'company',
      primary: 'isPrimary',
      postalCode: 'zip',
      middleName: 'mInitial',
      emailAddress: 'email',
      fName: 'first',
      lName: 'last',
      pNumber: 'phone',
    },
    renameArray: function(data, map) {
      for (let key in data) {
        if (data.hasOwnProperty(key) && map.hasOwnProperty(key)) {
          data[map[key]] = data[key];
          delete data[key];
        }
      }
    },
    unbindEvents: function(obj) {
      Object.keys(obj).forEach(function(key) {
        $(obj[key]).unbind('click').unbind('blur').unbind('change').unbind('touchstart');
      });
    },
    /**
     * Function used to notify the native web application that the user has been sucessfully
     * logged out of the costco website. This is needed as the app relies upon web view
     */
    notifyAppLogout: function() {
      console.log('notifying app of logout');
      try {
        if (typeof Android != 'undefined') {
          Android.logoutCostcoApp();
        } 
        else if (typeof webkit != 'undefined') {
          webkit.messageHandlers.logoutAction.postMessage('success');
        }
      } 
      catch (e) {
        console.warn(e);
      }
    },
    removeParam: function(key, sourceURL) {
      let rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },
    /**
     * Politically incorrect method for turning an array of objects in the form
     * of [{name:'hi',value:'robert'},{}..] into an equivalent object
     * '{hi: 'robert', hey: 'robert'}'. $(form).serializeArray() will return
     * the array of objects we're looking to convert
     * @param  {Array} arr The array of objects.
     * @return {Object}    The object equivalent of arr
     */
    objectifyArray: function(arr) {
      let obj = {};
      arr.forEach((arrObj) => {
        obj[arrObj.name] = arrObj.value;
      });
      return obj;
    },

    /**
     * Utility function for adjusting heights of arbitrary numbner of divs, setting it to the 'tallest' value
     * For this to happen two things must be the case:
     * #1 All the DIVs that need to be aligned should have same unique css class applied (convention is costco-align-height-some-arbitrary-name)
     * #2 call the function with string denoting applied class name, e.g. :
     *		adjustDivHeights('.costco-align-height-some-arbitrary-name');
     */

    /* Compare heights of all divs with applied css class and increase the 'smaller' ones to the height of the tallest */
    adjustDivHeights: function(alignClass, defaultHeight) {
      $arrDivs = $(alignClass);
      if ($arrDivs != null && $arrDivs.length > 0) {
        max = 0;
        $arrDivs.each(
          function() {
            max = Math.max(max, parseInt($(this).height()));
          }
        );
        if (max == 0 && typeof(defaultHeight) != 'undefined') {
          max = defaultHeight;
        }
        $arrDivs.each(
          function() {
            if ($(this).height() != max) {
              $(this).height(max);
            }
          }
        );
      }
    },
    /**
     * Capitalize a given string. Takes a string of form "Hi there Robert" and
     * returns "Hi There Robert".
     * @param  {String} str The string to capitalize
     * @return {String}     The capitalized string.
     */
    capitalize: function(str) {
      return str.split(' ')
        .map((x) => x.charAt().toUpperCase().concat(x.substr(1))).join(' ');
    },
    isUsOrCaZipCode: function() {    	
    	if ($('#B_countryId').length > 0 || $('#countryId').length > 0) {
    		return COSTCO.util.isUSOrCaAddressZip();
    	} else {
    		const storeId = wcs.storeId;
    		switch (storeId) {
        case '10301':
          return true;
        case '10302':
          return false;
        case '11301':
          return true;
        default:
          return false;
        }
		  }
    },
    isUSOrCaAddressZip: function() {
      let selCountry = $('#B_countryId').length > 0 ? $('#B_countryId').val() : $('#countryId').val();
      selCountry = selCountry+wcs.storeId;        
        switch (selCountry) {
          case 'US10301':
              return true;
          case 'CA10301':
              return false;
          case 'US10302':
              return true;
          case 'CA10302':
              return false;
          case 'US11301':
              return true;
          case 'CA11301':
              return false;
          case 'US11303':
              return true;
          case 'CA11303':
              return false;
          default:
              return 'false';     
        }
    },
    getMaxHeight: function(elems) {
      return Math.max.apply(null, elems.map(function() {
        return $(this).height();
      }).get());
    },
    /**
     * Checks if the current context is related to a grocery product. 
     */
    is2DayFlow: function() {
      	var is2DayFlow=$('#groceryIdentifier').length>0 && $('#groceryIdentifier').val()=='true'?true:false;   	
      	return is2DayFlow;
     },
      isLTLDeliveryServicesEnabled: function() {
    	  var ltlDeliveryServicesEnableFlag = $('#deliveryServicesEnabled').length > 0 && $('#deliveryServicesEnabled').val()=='true' ? true:false;      	
        	return ltlDeliveryServicesEnableFlag;
        },
      
    
    /**
     * dob Validation- Month and date range validation and leap year validation.
     * @param month 
     * @param day
     * @param year 
     */
    dateValidation: function(month,day,year) {
    	let isDateValid = false;
    	let currentYear = new Date().getFullYear();
        let beginningYear = currentYear - 100;
        if( typeof year !== 'undefined' && year !=="" && (year < beginningYear || year > currentYear)){
        	isDateValid = false;
        }
        else if ((month === "04" || month === "06" || month === "09" || month === "11") && day<=30 && day>=1){
        	isDateValid = true;
    	}
        // check for february 29th
    	else if (month === "02") { 
    		let isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
		  	if (day>=1 &&( day<29 || (day === "29" && isleap)) ){ 
		  		isDateValid = true;
		  	}
    	}
    	// Check for month and day range
    	else if (month>=1 && month<=12 && day<=31 && day>=1){
    		isDateValid = true;
    	}
    	else{
    		if((month ==="" || typeof month === 'undefined') && (year ==="" || typeof year === 'undefined' ) 
    				&& (COSTCO.util.isCAStore() || (day ==="" || typeof day === 'undefined'))){
    			isDateValid = true;
    		}
    	}
        return isDateValid;
    },
    /**
     * Function used to check if Global error exists on page.
     * @return {Boolean}
     */
    isGlobalErrorOnPage:  function () {
      let isGlobalError = false;
      let errorClasses = COSTCO.util.globalErrorElementClasses;

      jQuery.each(errorClasses, function(index, value) {
        $('.' + value).each(function(){
          if(($(this) !== 'undefined' && $(this).html() !== 'undefined' && $(this).html().trim().lenght > 0 )
        	  || ($(this).children() !== 'undefined' && $(this).children().html() !== undefined && $(this).children().html().trim().length > 0)) {
            let innerContent = $(this).children().html() !== undefined ? $(this).children().html() : $(this).html();
            if ($(this).length > 0 && innerContent.length > 1) {
              isGlobalError = true;
            }
          }
        });
      });

      return isGlobalError;
    },

    /**
     * Populates announcement screen reader div on page load
     */
    announceSRGlobalErrorMessage: function() {
      if (COSTCO.util.isGlobalErrorOnPage()) {
        let errorElement = COSTCO.util.getFirstGlobalErrorOnPage($('body'));
        if(errorElement !== undefined && errorElement !== null && errorElement.text()!== "") {
          let eMessage = errorElement.text();
          COSTCO.util.announceSRErrorMessage(eMessage);
        }
      }
    },

    /**
     * Function used to monitor screen reader announcement div element for changes
     */
    resetScreenReaderAnnouncement: function() {
      let targetObject = document.querySelector("#screen-reader-announcement");
      let observerObject =  new MutationObserver(function (mutationRecordsList) {
          mutationRecordsList.forEach(function(mutation) {
            if ("attributes" === mutation.type || "childList" ===  mutation.type ||  "subtree" ===  mutation.type) {
              setTimeout(function(){
                $(targetObject).empty();
              },2000);
            }
          });
        });
      if (targetObject !== undefined && targetObject !== null) {
        observerObject.observe(targetObject, {
          attributes: true,
          attributeOldValue: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    },
    
    /**
     * Function used to inject error message in screen reader placeholder announcement div
     * @param error message to be injected
     */
    
    announceSRErrorMessage: function(errorMessage) {
    	try {
    		errorMessage = errorMessage.trim();
    		let htmlContent = $.parseHTML(errorMessage);
          
    		if(htmlContent != null && !htmlContent.filter(function(e){ return e instanceof HTMLElement;}).length) {
    			errorMessage = '<p>' + errorMessage + '</p>';
    		}
          
    		let errorToAnnounce = $(errorMessage).html() !== undefined ? $(errorMessage).html() : errorMessage; 
    		COSTCO.util.announceSRMessage(messages.ERROR + ' ' + errorToAnnounce);
    	} catch(error) {
    	  	console.log("Error occurred while announcing SR message! Error: " + error);
    	}
    },
    
    /**
     * Moves the specified section to keep it in view when user scrolls.
     * The section only moves if the screen is Tablet Landscape or wider.
     * @param {string} elementId	ID of html element which is in view when user scrolls
     * @param {string} topReferenceElementId	ID of element which is initially top-aligned with "sticky element"
     * @param {string} bottomReferenceElementId ID of an element which presents a bottom limit to a moving "sticky element"
     */
    makeElementSticky: function(elementId, topReferenceElementId, bottomReferenceElementId) {
    
      let makeElementStickyFunction = function() {
    	  
        let stickyElement = $('#'+ elementId);
        let topReferenceElement = $('#' + topReferenceElementId);
        let bottomReferenceElement = $('#' + bottomReferenceElementId);
        
        let bottomReference = bottomReferenceElement.offset().top;
        
        if ( stickyElement.length > 0 && topReferenceElement.length > 0)  {
        	  let topReference = topReferenceElement.offset().top + topReferenceElement.height();

              let currentTranslateY = parseFloat(stickyElement.css('transform').split(',')[5]) || 0;
              let translateY = -stickyElement[0].getBoundingClientRect().top + currentTranslateY;
              let maxDistance = bottomReference - topReference - stickyElement.height();

              if (translateY > maxDistance) {
                translateY = maxDistance;
              } else if (translateY < 0) {
                translateY = 0;
              }

              stickyElement.css({
                '-webkit-transform': 'translateY(' + translateY + 'px)',
                '-moz-transform': 'translateY(' + translateY + 'px)',
                '-ms-transform': 'translateY(' + translateY + 'px)',
                '-o-transform': 'translateY(' + translateY + 'px)',
                'transform': 'translateY(' + translateY + 'px)',
              });
        }
      
      };
      $(window).on('scroll wheel DOMMouseScroll mousewheel resize', function(evt) {
        // remove all transforms if screen is not at least tablet landscape
        if (COSTCO.util.isMaxScreen('TABLET-LANDSCAPE')) {
          $('#' + elementId).css({
            '-webkit-transform': '',
            '-moz-transform': '',
            '-ms-transform': '',
            '-o-transform': '',
            'transform': '',
          });
        } else {
          makeElementStickyFunction();
        }
      });
    },
    preventBackButtonForSso: function(referer){
    	
    		try{
    			setTimeout(function(){
    	    		history.pushState(null, null, window.location);
    	    		window.addEventListener('popstate', function(event) {
    	    			if(referer != null && referer != undefined && referer != '' 
    	    	    		&& (referer.indexOf('signin-qa.costco.com') >-1 || referer.indexOf('signin.costco.com') >-1)){
    	    				alert(1);
    	    				history.pushState(null, null, window.location);
    	    			}
    	    		});	
    	    	}, 5000);

    		}catch(e){
    			console.error(e);
    		}
    	 
    },
    /**
     * Method return date in yyyy-dd-mm-dd format
     */
    formatCalendarDate: function(date,separator) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        if(separator === '-'){
        	return [year, month, day].join('-');
        }else{
        	return [month, day, year.toString().substr(-2)].join('/');
        }
    },
   getAllCalendarAvailableDates:  function(dates) {
        let availableDates= [];
        dates.forEach(function(allowed_obj) {
        if (allowed_obj.date_str) {
          let date =new Date(allowed_obj.date_obj);
          let timeZoneCorrectDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
	   	  // East of GMT
          if (date.getTimezoneOffset() < 0) {
    		timeZoneCorrectDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
     	  }
          let formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
          let availableFormatedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
          availableDates.push(availableFormatedDate); 
        }
      });
      return availableDates;
      },
	
    //Controls continue button on Membership Privileges and Conditions page
    continueAfterTermsAccepted: function() {
        if($("#tnc-checkbox").attr("value") == "true"){
        	if ($('#upgradeOnly').val() == "true") {
        		window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true&upgradeOnly=true';
			} else {
				window.location.href = '/QuickMembershipCheckoutCmd?isTandCAccepted=true';
			}
        } else{
        	
        	$(".membership-tnc-checkbox-main").css({'border': '2px solid #D32029', 'margin': '0px' });
        	$("#terms-conditions-error").removeClass("hidden").css('margin-bottom', '20px');
        	$('#tnc-checkbox').focus();
        	$("#tnc-checkbox").attr("aria-describedby","terms-conditions-error");

        }       
      },
    
    //Functionality for accept check box on Membership Privileges and Conditions page 
    toggleTermsCheckbox: function() {
        if ($("#tnc-checkbox").attr("value") == "false"){
        	$("#tnc-checkbox").removeAttr("aria-describedby");
        	$("#tnc-checkbox").attr("value", "true");
        	$("#tnc-checkbox").attr("checked", "checked");
        	if(!$("#terms-conditions-error").hasClass("hidden")){
        		$("#terms-conditions-error").addClass("hidden");
        		$(".membership-tnc-checkbox-main").css({'border': '1px solid #cccccc', 'margin': '5px 0px 20px 0px' });
        	}
        }else{
        	$("#tnc-checkbox").attr("value", "false");
        	$("#tnc-checkbox").removeAttr("checked");
        }    
      },
      
      // function for sanitizing data to prevent XSS attacks
      replaceSpecialChars: function(obj)
      {
         var result = new String(obj);

         result = result.replace(/&/g, "&amp;");
         result = result.replace(/</g, "&lt;");
         result = result.replace(/>/g, "&gt;");
         result = result.replace(/'/g, "&#39;");
         result = result.replace(/"/g, "&quot;");
         result = result.replace(/\//g, "&#47;");
         result = result.replace(/\\/g, "&#92;"); 

         return result;
      },
      
      scrubSpecialChars: function(obj)
      {
         var result = new String(obj);
         result = result.replace(/[\%\$\`\\\*\<\>\(\)]*/g, '');
         return result;
      },
      
      scrubSpecialCharsFromCompanyName: function(obj)
      {
         var result = new String(obj);
         result = result.replace(/[\%\$\`\~\*\<\>]*/g, '');
         return result;
      }
    
  };

  return util;
});


// WEBPACK FOOTER //
// ./js/global/utility2.js